import { emitClickEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const { labels } = cinemaTracking;
    const parsedCinemaIndex = Number.parseInt(cinemaIndex, 10);
    const featureNumber = Number.isNaN(parsedCinemaIndex) ? undefined : parsedCinemaIndex === 99 ? 99 : parsedCinemaIndex + 1;

    return {
        ...cinemaTracking,
        position: Number(featureIndex),
        status: "clicked",
        labels: {
            ...labels,
            promo_Feature: ["true"],
            ...(featureNumber && { promo_FeatureNumber: [`${featureNumber}`] }),
            promo_FilledSlots: labels.promo_FilledSlots,
            ...additionalTrackingLabels,
        },
    };
};
const buildRecommendation = (recommendationTracking) => ({
    ...recommendationTracking,
    status: "clicked",
});

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

/**
 *
 */
export default ({
    cinemaTracking,
    recommendationTracking,
    featureIndex,
    cinemaIndex,
    additionalCinemaClickTracking,
    additionalRecommendationClickTracking,
    cinemaMeta,
    recommendationMeta,
    additionalTrackingLabels,
    additionalNextPiTrackingLabels,
}) => {
    const event = {
        name: "click",
        features: [
            buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels),
            buildRecommendation(recommendationTracking),
        ],
    };

    const cleanRecommendationMeta = { ...recommendationMeta };
    delete cleanRecommendationMeta.product_VariationId;
    const additionalClickTrackingLabels = {
        ...additionalCinemaClickTracking,
        ...additionalRecommendationClickTracking,
        ...cleanRecommendationMeta,
        ...cinemaMeta,
    };
    emitClickEvent(event, { ...additionalNextPiTrackingLabels, promo_Click: cinemaTracking.name }, additionalClickTrackingLabels);
};
